import { Sprite } from 'pixi.js'
import Layer from '@/scripts/canvas/Layer'
import gsap from 'gsap'
import { playMorseLoop } from './morse'
import { IItemInfo } from '@/scripts/data/types'

export function addSirokoMorse(
  layer: Layer,
  def: IItemInfo,
  messages: string[],
  timings: {
    dot: number
    dash: number
    symbolGap: number
    letterGap: number
    wordGap: number
    messageGap: number
  },
  startDelaySeconds: number = 5,
) {
  const s = Sprite.from('siroko.png')
  s.position.set(def.x, def.y)
  s.zIndex = 3
  s.eventMode = 'none'
  s.visible = false
  layer.addChild(s)

  gsap.delayedCall(startDelaySeconds, () => {
    playMorseLoop(s, messages, timings)
  })
}
